if (typeof document !== 'undefined' && process.env.NODE_ENV !== 'test' && !document.head.querySelector("style[data-wp-hash='020f606c18']")) {
	const style = document.createElement("style");
	style.setAttribute("data-wp-hash", "020f606c18");
	style.appendChild(document.createTextNode(".boot-save-button{width:100%}.boot-save-button__shortcut:not(:first-child){margin-left:8px}"));
	document.head.appendChild(style);
}
